import ctx from "@/ctx";
import fetch from "../../utils/fetch";

function formatLabel(item) {
  if (!item) return "";
  const code = item.code != null ? String(item.code).trim() : "";
  const name = item.name != null ? String(item.name).trim() : "";
  if (code && name) return `${code} ${name}`;
  return name || code || "";
}

let Items = function(d) {
  let self = this;
  self.items = (Array.isArray(d) ? d : []).map(i => ({
    ...i,
    label: formatLabel(i)
  }));

  self.get = function(id) {
    if (id == null || id === "") return undefined;
    return self.items.find(i => i.id == id);
  };

  self.format = formatLabel;
};

export default async () => {
  console.log("ctx.src.diagnosis: loaded");
  const res = await fetch.get("/api/medcases/diagnosis/get-all");
  if (res) ctx.src.diagnosis = new Items(res);
  console.log("ctx.src.diagnosis: initialized");
};
